"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterObjectKeys = exports.PipedriveEntityType = exports.AjaxUrlType = void 0;
const filterObjectKeys = (obj = {}, keys = []) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (!keys.includes(key)) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
};
exports.filterObjectKeys = filterObjectKeys;
const PipedriveEntityType = exports.PipedriveEntityType = {
  DEAL: 'deal',
  PERSON: 'person'
};
const AjaxUrlType = exports.AjaxUrlType = {
  LEAD_CAPTURE: 'leadCapture',
  MMC_REQUEST_CALL_MODAL_PAYMENTS: 'mmc_request_call_modal_payments'
};